import React, {useEffect, useState, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import styles from "./styles.module.scss";
import {
    Table,
    Button,
    LightTextButton,
    FilterDropdown,
    SwitchButton,
    ImageStamp,
    TextLink,
    TextInput,
    Status,
    Search
} from "components";
import {customersAction, classActivityAction} from "redux/actions";
import EditClassSessionPopup from "../popups/Routing/EditClassSessionPopup";
import {useHistory, useLocation} from "react-router-dom";
import * as XLSX from "xlsx";
import {Modal} from "@material-ui/core";
import ReportModal from "../../Report/ReportModal";
import MemberProfileDetailsModal from "../../Report/MemberProfileDetailsModal";
import {adminToken} from "../../../helper";
import axios from "axios";
import {AWS_URL_UM_INT_8089, AWS_SERVER_APIS} from "../../../configurations";
// import MemberProfileDetailsModal from "../modals/MemberProfileDetailsModal";
import SubscriptionModal from "../../Customers/modals/SubscriptionModal";
// import UpdateGrandAPPSeniorModel from "../modals/UpdateGrandAPPSeniorModel";

const initialState = {
    mobile: "",
    sp_mobile: "",
    display_package_name: "",
    session_status: "",
    booking_status: "",
    class_date:"",
    session_id:""
};

export default function ClassActivityPanel() {
    // Routers
    const {push, location} = useHistory();

    const [openModal, setOpenModal] = useState(false)
    const [refreshPage, setRefreshPage] = useState(null)

    const handleOpenModal = () => {
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const [openCusModal, setOpenCusModal] = useState(false)

    const handleCloseCusModal = () => {
        setOpenCusModal(false)
    }

    const [openSubscriptionModal, setOpenSubscriptionModal] = useState(false)

    const handleOpenSubscriptionModal = () => {
        setOpenSubscriptionModal(true)
    }

    const handleCloseSubscriptionModal = () => {
        setOpenSubscriptionModal(false)
    }

    const [clickedCustomer, setClickedCustomer] = useState(null)
    const [clickedElder, setClickedElder] = useState(null)
    const [clickedSubscription, setClickedSubscription] = useState(null)
    const [openModalUpdateSenior, setOpenModalUpdateSenior] = useState(false);

    const handleOpenModalUS = () => {
        setOpenModalUpdateSenior(true)
    }
    const handleCloseUS = () => {
        setOpenModalUpdateSenior(false)
    }

    // Query based filter
    const locationSearch = useLocation().search;
    const query = new URLSearchParams(locationSearch);
    const userID = 1;//query.get("userID");

    // States
    const [tableRows, setTableRows] = useState();
    const [editableDetail, setEditableDetails] = useState();
    const [isPopupVisible, setPopupVisible] = useState();

    // const [filterState, setFilterState] = useState(false)

    // Filter States
    const [status, setStatus] = useState();
    const [filterState, setfilterState] = useState(initialState);
    const [activeStatus, setActiveStatus] = useState(11);
    const [randomkey, setRandomkey] = useState(0);
    

    // Redux actions
    const dispatch = useDispatch();
    const {customers, classActivity, userRole} = useSelector(state => ({
        customers: state.customers,
        classActivity: state.classActivity,
        userRole: state.userRole?.filter(role => role.module === "Lifestyle Activities")
    }));


    useEffect(() => {
        if (userRole?.find(item => item.privilege === "Read"))
            dispatch(classActivityAction.get());
            // dispatch(customersAction.get(1));
        return () => dispatch(classActivityAction.reset());
    }, [activeStatus]);

    // const onPageChange = e => dispatch(customersAction.get(e));
    const onPageChange = e => dispatch();

    const handleOpenCusModal = (fname) => {
        console.log(JSON.stringify(filterState));
        dispatch(
            customersAction.search({
                pageNumber: 1,
                query: fname
            })
        )
        setOpenCusModal(true)
    }

    const onChange = e => setfilterState({...filterState, [e.target.name]: e.target.value});

    // internal search
    const internalSearch = (searchBy, rows) => {
        if (!filterState?.[searchBy]) return rows;

        const filteredRows =
            rows?.length &&
            rows.filter(
                item =>
                    item[searchBy]
                        ?.toString()
                        .toLowerCase()
                        .indexOf(filterState?.[searchBy]?.toLowerCase()) !== -1
            );

        return filteredRows;
    };

    // internal search for user details sub arrsy
    const internalSearchUser = (searchBy, rows) => {
        if (!filterState?.[searchBy]) return rows;
        const filteredRows =
            rows?.length &&
            rows.filter(
                item =>
                    item['get_user'][searchBy]
                        ?.toString()
                        .toLowerCase()
                        .indexOf(filterState?.[searchBy]?.toLowerCase()) !== -1
            );

        return filteredRows;
    };

    useEffect(() => {
        if (!classActivity?.length) {
            setTableRows();
            return;
        }

        let filtered = classActivity;
        
        if (userRole?.find(item => item.privilege === "Read")){
            filtered = internalSearch("mobile", filtered);
            filtered = internalSearch("sp_mobile", filtered);
            filtered = internalSearch("display_package_name", filtered);
            filtered = internalSearch("session_status", filtered);
            filtered = internalSearch("booking_status", filtered);
            filtered = internalSearch("class_date", filtered);
            filtered = internalSearch("session_id", filtered);
            // filtered = internalSearch("package_name", filtered);
            //filtered = internalSearchUser("package_name", filtered);
        }

        let newData = [];
        // Map table rows
        filtered?.forEach(obj => {
            const data = {
                id: obj?.booking_id,
                session_id: obj?.session_id,
                user_id: (
                            <TextLink
                                text={obj?.user_id}
                                onClick={() => {
                                    // push(`${location.pathname}/${obj?.userId}`)
                                    setClickedCustomer({id: obj?.user_id, mobile: obj?.mobile, name: obj?.user_name})
                                    handleOpenCusModal(obj?.user_name?.split(' ')[0])
                                }}
                            />
                        ),
                user_name: obj?.user_name,
                user_mobile: obj?.mobile,
                package: obj?.display_package_name,
                package_img: <ImageStamp src={obj?.display_package_image}/>,
                cart_id: obj?.cart_id,
                subscription_id: (
                                <TextLink
                                    text={obj?.subscription_id}
                                    onClick={() => {
                                        setClickedSubscription({id: obj?.subscription_id, userId: null})
                                        handleOpenSubscriptionModal()
                                        // push(`/subscription/orders/${obj.id}`)
                                    }}
                                />
                            ),
                base_price: obj?.base_price,
                selling_price: obj?.selling_price,
                join_url: (
                            <TextLink
                                    text={obj?.join_url}
                                    onClick={() =>
                                        window.open(
                                            `${obj?.join_url}`,
                                            "_blank"
                                        )
                                    }
                                />
                            ),
                sp_id: obj?.sp_id,
                sp_name: obj?.sp_name,
                sp_mobile: obj?.sp_mobile,
                booking_status: obj?.booking_status,
                session_status: obj?.session_status,
                class_date: `${new Date(obj?.class_date).toLocaleDateString("en-GB")}`,
                class_time: obj?.class_time
            };
            newData.push(data);
        });

        setTableRows(newData);
    }, [classActivity, status, filterState]);

    // Search based on category & sub category name
    const onSearch = () => {
    };

    // Table Header
    const tableHeaders = useMemo(
        () => [
            {
                title: "ID",
                sortBy: "id"
            },
            {
                title: "Session",
                sortBy: "session_id"
            },
            {
                title: "Customer",
                sortBy: "user_id"
            },
            {
                title: "Name"
            },
            {
                title: "Mobile"
            },
            {
                title: "Package"
            },
            {
                title: "Image"
            },
            {
                title: "Cart",
                sortBy: "cart_id"
            },
            {
                title: "Subscription",
                sortBy: "subscription_id"
            },
            {
                title: "Base Price"
            },
            {
                title: "Selling Price"
            },
            {
                title: "Class Join URL"
            },
            {
                title: "Provider",
                sortBy: "sp_id"
            },
            {
                title: "SP Name"
            },
            {
                title: "SP Mobile"
            },
            {
                title: "Booking Status",
                sortBy: "booking_status"
            },
            {
                title: "Session Status",
                sortBy: "session_status"
            },
            {
                title: "Class Date",
                sortBy: "class_date"
            },
            {
                title: "Class Time",
                sortBy: "class_time"
            }
        ],
        [tableRows]
    );
    //v2-app
    const exportDataFunc = () => {
        adminToken()
            .then(token =>
                axios.get(
                    `${AWS_SERVER_APIS}/getallclasssessions`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                ).then((response) => {
                        const rows = response.data.data.map(item => {
                            return {
                                "ID": item.id,
                                "Package": item.package_id,
                                "Class Date": item.class_date,
                                "Class Time": item.class_time,
                                "Provider": item.sp_id,
                                "Join URL": item.join_url,
                                "Status": item.status,
                                "Sub Category": item.sub_category_id,
                                "Package Name": item.package_name,
                                "Package Image URL": item.package_image_url,
                                "Created At": item.created_at,
                                "Updated At": item.updated_at
                            }
                        })

                        const worksheet = XLSX.utils.json_to_sheet(rows);
                        const workbook = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
                        //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
                        //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
                        XLSX.writeFile(workbook, "DataSheet.xlsx");
                    }
                )
            )
    }

    return (
        <div>
            <div className={styles.filter}>
                <TextInput
                    label="Session"
                    name="session_id"
                    type="text"
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    style={{width: 150}}
                    value={filterState?.session_id}
                />

                <TextInput
                    label="Session Date"
                    name="class_date"
                    type="date"
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    style={{width: 150}}
                    value={filterState?.class_date}
                />

                <TextInput
                    label="Mobile"
                    name="mobile"
                    type="text"
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    style={{width: 150}}
                    value={filterState?.mobile}
                />

                <TextInput
                    label="Provider Mobile"
                    name="sp_mobile"
                    type="text"
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    style={{width: 150}}
                    value={filterState?.sp_mobile}
                />
                <TextInput
                    label="Package"
                    name="display_package_name"
                    type="text"
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    style={{width: 150}}
                    value={filterState?.display_package_name}
                />
                <div style={{margin: "0 0 11px"}}>
                <FilterDropdown
                    onChange={onChange}
                    name="session_status"
                    label="Session Status"
                    options={['','scheduled','cancelled','completed']}
                    value={filterState?.session_status}
                    values={['','scheduled','cancelled','completed']}
                />
                </div>
                {/* <TextInput
                    label="Package Name"
                    name="package_name"
                    type="text"
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    style={{width: 150}}
                    value={filterState?.package_name}
                /> */}

                {/* <button className={'btn btn-primary m-auto'} style={{margin: 10}}
                        onClick={exportDataFunc}
                >Export Data
                </button> */}

                {/*<LightTextButton onClick={() => setfilterState(initialState)}/>*/}
            </div>
            <div>
            <FilterDropdown
                    onChange={onChange}
                    name="booking_status"
                    label="Booking Status"
                    options={['','booked','rescheduled','cancelled','completed']}
                    value={filterState?.booking_status}
                    values={['','booked','rescheduled','cancelled','completed']}
                />
            </div>
            
            {/* totalPage: Math.ceil(customers?.count / 10) */}

            <Table
                headers={tableHeaders}
                data={tableRows}
                current={classActivity?.pageNumber}
                totalPage={0}
                state={filterState !== initialState}
                length={tableRows?.length}
                r_length={classActivity?.data?.length}
                t_length={classActivity?.count}
                exportData={false}
                // exportDataFunc={exportDataFunc}
            />

            <Modal
                open={openSubscriptionModal}
                onClose={handleCloseSubscriptionModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <SubscriptionModal clickedSubscription={clickedSubscription} handleCloseModal={handleCloseSubscriptionModal}/>
            </Modal>

            <Modal
                open={openCusModal}
                onClose={handleCloseCusModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <ReportModal clickedCustomer={clickedCustomer} handleCloseModal={handleCloseCusModal}
                             setClickedSubscription={setClickedSubscription}
                             handleOpenSubscriptionModal={handleOpenSubscriptionModal}/>
            </Modal>

        </div>
    );
}
